var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBlocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.85C7.26667 15.85 7.07083 15.7708 6.9125 15.6125C6.75417 15.4542 6.675 15.2583 6.675 15.025C6.675 14.7917 6.75417 14.5958 6.9125 14.4375C7.07083 14.2792 7.26667 14.2 7.5 14.2C7.73333 14.2 7.92917 14.2792 8.0875 14.4375C8.24583 14.5958 8.325 14.7917 8.325 15.025C8.325 15.2583 8.24583 15.4542 8.0875 15.6125C7.92917 15.7708 7.73333 15.85 7.5 15.85ZM6.775 13.1V6.4H8.275V13.1H6.775ZM2 22C1.6 22 1.25 21.85 0.95 21.55C0.65 21.25 0.5 20.9 0.5 20.5V1.5C0.5 1.1 0.65 0.75 0.95 0.45C1.25 0.15 1.6 0 2 0H13C13.4 0 13.75 0.15 14.05 0.45C14.35 0.75 14.5 1.1 14.5 1.5V20.5C14.5 20.9 14.35 21.25 14.05 21.55C13.75 21.85 13.4 22 13 22H2ZM2 19.75V20.5H13V19.75H2ZM2 18.25H13V3.75H2V18.25ZM2 2.25H13V1.5H2V2.25ZM2 2.25V1.5V2.25ZM2 19.75V20.5V19.75Z",
    fill: "#4589EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBlocker);
export default __webpack_public_path__ + "static/media/loginBlocker.5de4f16f.svg";
export { ForwardRef as ReactComponent };